const html = require('choo/html');
const { list } = require('../utils');
const archiveTile = require('./archiveTile');
const modal = require('./modal');
const intro = require('./intro');

module.exports = function(state, emit) {
  if (state.user.loginRequired && !state.user.loggedIn) {
    emit('signup-cta', 'required');
  }
  const archives = state.storage.files
    .filter(archive => !archive.expired)
    .map(archive => archiveTile(state, emit, archive));
  let left = '';
  if (state.uploading) {
    left = archiveTile.uploading(state, emit);
  } else if (state.archive.numFiles > 0) {
    left = archiveTile.wip(state, emit);
  } else {
    left = archiveTile.empty(state, emit);
  }
  archives.reverse();
  const right =
    archives.length === 0
      ? intro(state)
      : list(archives, 'p-2 w-full', 'mb-4 w-full');

  return html`
    <main class="main">
      ${state.modal && modal(state, emit)}
      <section
        class="w-full p-4 md:p-10 flex flex-col md:flex-row md:items-stretch md:rounded-2xl md:shadow-2xl bg-white dark:bg-grey-90 backdrop-blur-sm gap-8"
      >
        <div class="w-full md:w-1/2 flex-shrink-0 min-h-0">${left}</div>
        <div class="w-full md:w-1/2 flex-grow min-h-0">${right}</div>
      </section>
    </main>
  `;
};
